export const removeTagsFromString = (text: string): string => {
  const div = document.createElement('div');
  div.innerHTML = text;

  return div.textContent || div.innerText || '';
};
